import { get, post, put, del } from '../utils/api';

/**
 * 产品服务
 */
export const productService = {
  // 获取产品列表
  getProductList: async (page = 1, size = 10, keyword = '') => {
    const response = await get('/products', { page, size, keyword });
    return response.data;
  },

  // 获取活跃产品（前端展示用）
  getActiveProducts: async () => {
    const response = await get('/products/active');
    return response.data;
  },

  // 获取产品详情
  getProductById: async (id) => {
    const response = await get(`/products/${id}`);
    return response.data;
  },
};

